import { type UseFormReturn } from 'react-hook-form';
import { useRegisterCoordinatedForm } from './useRegisterCoordinatedForm.tsx';

export interface IRegisterCoordinatedFormProps {
  id?: string | null;
  methods: UseFormReturn;
}

/**
 * Registra il form all'interno del FormCoordinator.
 * Utilizziamo un componente dedicato per evitare il re-render del tree
 * sottostante.
 */
export function RegisterCoordinatedForm(props: IRegisterCoordinatedFormProps) {
  useRegisterCoordinatedForm({
    id: props.id,
    methods: props.methods,
  });

  return null;
}
